import { Fieldset as BaseFieldset, type FieldsetRootProps } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { fieldRootStyle } from '../Field/FieldRoot.css';
import { fieldGroupRootStyle } from './FieldGroupRoot.css';

type Props = FieldsetRootProps;

export const FieldGroupRoot = ({ ...delegated }: Props) => {
  return <BaseFieldset.Root {...delegated} className={clsxs(fieldRootStyle, fieldGroupRootStyle, delegated.className)} />;
};
